import useCommonResponsiveValues from 'app/hooks/useCommonResponsiveValues'
import {
	Box,
	VStack,
	Text,
	useBreakpointValue,
	HStack,
	Button,
} from 'native-base'
import colors from 'app/colors'
import useRoute from 'app/features/main/hooks/useRoute'
import { Fragment } from 'react'
import { Error as ErrorIcon } from '@bridge/ui/icons-material'

const IntroSection5 = () => {
	const { containerWidth } = useCommonResponsiveValues()
	const { routeGeneralFAQ } = useRoute()

	const textSize1 = useBreakpointValue({
		base: 'h3/800',
		lg: 'h2/900/main',
	})

	const textSize2 = useBreakpointValue({
		base: 'p_s/600',
		lg: 'h5/500/main',
	})

	const textSize4 = useBreakpointValue({
		base: 'h6/700',
		lg: 'h5/700',
	})

	const textSize6 = useBreakpointValue({
		base: 'p_m/600',
		lg: 'h6/600',
	})

	const textSize7 = useBreakpointValue({
		base: 'p_m/500',
		lg: 'h6/500',
	})

	const buttonWidth = useBreakpointValue({
		base: '343px',
		lg: '475px',
	})

	return (
		<Box
			py={{ base: '60px', lg: '150px' }}
			bgColor={{
				linearGradient: {
					colors: ['#000000cc', '#28303D'],
					start: [1, 0],
					end: [1, 1],
				},
			}}
			alignItems="center"
		>
			<VStack px="16px" w={containerWidth} alignItems="center">
				<Text color="singletons.white" size={textSize1}>
					FAQ
				</Text>
				<Box h={{ base: '24px', lg: '32px' }} />
				<Text color="gray.400" size={textSize2}>
					종합학습진단에 대해 더 궁금한게 있으신가요?
				</Text>
				<Box h={{ base: '24px', lg: '32px' }} />
				<Button
					variant="outline"
					w={buttonWidth}
					h="60px"
					_text={{
						color: 'singletons.white',
					}}
					bgColor={colors.transparent}
					borderColor="singletons.white"
					_hover={{
						bgColor: '#ffffff1f',
						borderColor: 'singletons.white',
					}}
					_pressed={{
						bgColor: '#ffffff1f',
						borderColor: 'singletons.white',
					}}
					onPress={routeGeneralFAQ}
				>
					FAQ 바로가기
				</Button>
				<Box h={{ base: '40px', lg: '60px' }} />
				<VStack
					px={{ base: '16px', lg: '40px' }}
					py="40px"
					w="100%"
					bgColor="gray.800"
					borderRadius="20px"
				>
					<HStack alignItems="center" space="10px">
						<ErrorIcon color='primary' />

						<Text size={textSize4} color="singletons.white">
							상품 이용안내
						</Text>
					</HStack>
					<Box h={{ base: '24px', lg: '40px' }} />
					<VStack space="40px">
						{ProductGuideList.map((item, index) => {
							return (
								<ProductGuideItem
									key={index}
									item={item}
									categoryTextSize={textSize6}
									guideTextSize={textSize7}
								/>
							)
						})}
					</VStack>
				</VStack>
			</VStack>
		</Box>
	)
}

export default IntroSection5

type ProductGuideItemType = {
	category: string
	guide: string[]
}

const ProductGuideList = [
	{
		category: '종합학습진단 관련',
		guide: [
			'종합학습진단 진행 후 1:1 All Care Pack 상품을 구매하신 경우, 진단결과를 불러올 수 있습니다.',
		],
	},
	{
		category: '중단/환불 정책',
		guide: [
			'종합학습진단 시행 전일 경우, 서비스 이용대금 전액 환불해드립니다.',
			'종합학습진단이 진행 중이거나 완료된 경우, 서비스 이용이 완료된 것으로 간주하여 환불이 불가합니다.',
		],
	},
	{
		category: '결제 정책',
		guide: [
			'상품은 카드결제를 통해 결제 가능합니다.',
			'카드 할부 결제가 가능하며 무이자 할부 개월 수는 각 카드사 및 결제 대행사(PG사) 할부 프로모션에 따라 상이합니다.',
			'무이자 카드 혜택은 고객센터 페이지에서 확인 가능합니다.',
		],
	},
]

type ProductGuideItemProps = {
	item: ProductGuideItemType
	categoryTextSize: string
	guideTextSize: string
}

const ProductGuideItem = ({
	item,
	categoryTextSize,
	guideTextSize,
}: ProductGuideItemProps) => {
	return (
		<>
			<VStack space="16px">
				<Text size={categoryTextSize} color="singletons.white">
					{item.category}
				</Text>
				<VStack>
					{item.guide.map((value, idx) => {
						return (
							<Fragment key={idx}>
								<HStack space="6px">
									<Text color="gray.400" size={guideTextSize}>
										&#x2022;
									</Text>
									<Text color="gray.400" size={guideTextSize}>
										{value}
									</Text>
								</HStack>
							</Fragment>
						)
					})}
				</VStack>
			</VStack>
		</>
	)
}
